/**
 * Confirm dialog for deleting an agent — shared by the agent list and the
 * editor so the copy stays identical. Deletion cascades server-side
 * (documents, chunks, calls); an assigned phone number is kept and simply
 * becomes unassigned.
 */

import { Button } from "./Button";
import { Modal } from "./Modal";

export interface DeleteAgentModalProps {
  open: boolean;
  agentName: string;
  deleting: boolean;
  error?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

export function DeleteAgentModal({
  open,
  agentName,
  deleting,
  error,
  onCancel,
  onConfirm,
}: DeleteAgentModalProps) {
  return (
    <Modal
      open={open}
      onClose={() => {
        if (!deleting) onCancel();
      }}
      title="Delete agent"
      footer={
        <>
          <Button onClick={onCancel} disabled={deleting}>
            Keep it
          </Button>
          <Button variant="danger" loading={deleting} onClick={onConfirm}>
            Delete agent
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-2">
        <p className="text-sm text-body">
          Delete <span className="font-medium text-bright">{agentName}</span>? This deletes the
          agent, its knowledge, and its call history. Any assigned phone number is kept and
          becomes unassigned. This can't be undone.
        </p>
        {error && (
          <p role="alert" className="text-sm text-danger">
            {error}
          </p>
        )}
      </div>
    </Modal>
  );
}
